import React, { FunctionComponent, createContext, useReducer } from 'react';
import {
  userStatusReducer,
  UserStatusAction,
  IUserStatusState,
  initialUserStatusState,
} from './userStatusReducer';

export const UserStatusContext = createContext<{
  state: IUserStatusState;
  dispatch: React.Dispatch<UserStatusAction>;
}>({
  state: initialUserStatusState,
  dispatch: () => null,
});

export const UserStatusProvider: FunctionComponent = (props): JSX.Element => {
  const [state, dispatch] = useReducer(
    userStatusReducer,
    initialUserStatusState,
  );

  return (
    <UserStatusContext.Provider value={{ state, dispatch }}>
      {props.children}
    </UserStatusContext.Provider>
  );
};
